/**
 * Manager's My Account page — the target of the user-menu "Preferences" item
 * (`primary-nav.tsx`) and of the access screens. Pro Studio has no account route
 * of its own.
 */
export const buildMyAccountUrl = (
  managerUrl: string | undefined,
  defaultOrgId: string | undefined
): string =>
  `${managerUrl ?? ''}${defaultOrgId ? `/organization/${defaultOrgId}` : ''}/my-account`;
